// Transform a pending patient API node to unified row shape
export const transformPendingPatient = (node) => ({
  id: node.id,
  name: node.name,
  email: node.email,
  phone: node.phoneNumber,
  dateOfBirth: node.dateOfBirth,
  sex: node.sex,
  kitCode: node.kitCode,
  createdAt: node.createdAt,
  updatedAt: node.updatedAt || null,
  status: node.status,
  physicianName: node.physician?.name || null,
  physicianId: node.physician?.id || null,
  physicianNotes: node.physicianNotes || null,
  emailLastSentAt: node.emailLastSentAt || null,
  reminderCount: node.reminderCount || 0,
  firstName: node.firstName || null,
  lastName: node.lastName || null,
  patientType: 'pending',
  avatarUrl: null,
  reviewCount: null,
  totalReportCounts: null,
  assignedStaff: null,
});

// Transform a Member node from the `members` query to unified row shape.
// Input is shaped like: { id, user, relationshipKind, viewerRole, assignedStaffRole, ... }
// The user subfield holds all the patient data (replaces the old .member field).
export const transformActivePatient = (row) => {
  const physician = row?.user?.assignedStaff?.find(s => s?.role === 'FELLOW');
  return {
    ...row?.user,
    kitCode: row?.user?.kits?.[0]?.accessionId || '',
    reviewCount: row?.user?.reportSummary?.inReviewCount || 0,
    totalReportCounts: row?.user?.reportSummary?.totalCount || 0,
    patientType: 'active',
    status: null,
    physicianName: physician?.staff?.name || null,
  };
};

// Map pending patient status to a search-friendly payment label
export const paymentLabel = (status) => {
  if (status === 'PENDING') return 'unpaid';
  return (status || '').toLowerCase();
};

// Build the input object for the UpdatePendingPatient mutation
// Only includes fields that have changed from original data
export const buildUpdatePendingPatientInput = ({ id, firstName, lastName, email, phone, dateOfBirth, sex, physicianNotes }) => {
  const input = { id };
  if (firstName !== undefined) input.firstName = firstName;
  if (lastName !== undefined) input.lastName = lastName;
  if (email !== undefined) input.email = email;
  if (phone !== undefined) input.phoneNumber = phone;
  if (dateOfBirth !== undefined) input.dateOfBirth = dateOfBirth;
  if (sex !== undefined) input.sex = sex;
  if (physicianNotes !== undefined) input.physicianNotes = physicianNotes;
  return input;
};
